import angular from 'angular';
import { getDuplicateRelationNameIds } from '@/shared/components/RelationName';

angular.module('cloudX').directive('uibSearchRelation', [
  '$compile',
  '$parse',
  '$filter',
  'resourceFactorySvc',
  function($compile, $parse, $filter, resourceFactorySvc) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true,
      //scope: true,
      link: function(scope, el, attrs) {
        var relationResource = resourceFactorySvc.get('relation');

        el.removeAttr('uib-search-relation'); //Remove own attribute to prevent endless compile loop

        const ignoreAliasGetter = $parse(attrs.ignoreAlias);

        scope.ignoreAlias = ignoreAliasGetter(scope);

        scope.$watch(
          function() {
            return ignoreAliasGetter(scope);
          },
          function(newVal, _) {
            scope.ignoreAlias = newVal;
          },
        );

        el.attr(
          'uib-typeahead',
          'item as (item | relationName:null:null:ignoreAlias | sanitize) for item in $uibSearchCustomer($viewValue)',
        );

        el.attr('id', 'RelationField');
        el.attr('typeahead-select-on-exact', 'true');
        el.attr('typeahead-min-length', '2');
        el.attr(
          'typeahead-template-url',
          'assets/templates/common/directives/uibSearchRelationTemplate.tpl.html',
        );
        el.attr('autocomplete', 'off');
        if (!attrs.placeholder) el.attr('placeholder', "{{'Search relation'|translate}}");

        scope.$uibSearchCustomerRequest = null;
        scope.$uibSearchCustomer = function(searchValue) {
          //Cancel previous request, cancelling a completed request will have no effect
          if (scope.$uibSearchCustomerRequest && scope.$uibSearchCustomerRequest.$cancelRequest)
            scope.$uibSearchCustomerRequest.$cancelRequest();

          var params = {
            take: 20,
            includeInactive: false,
            crmTypes: [],
            type: null,
            forInvoice: false,
          };
          if (attrs.searchOptions) {
            angular.extend(params, $parse(attrs.searchOptions)(scope));
          }
          params.searchValue = searchValue;
          scope.$uibSearchCustomerRequest = relationResource.names(params);
          return scope.$uibSearchCustomerRequest.$promise.then(function(items) {
            // Flag relations sharing a name so the template shows their code to tell them apart.
            // $$ prefix keeps the flag out of angular.toJson when the selected relation is posted.
            var duplicateIds = getDuplicateRelationNameIds(items, function(item) {
              return $filter('relationName')(item, null, null, scope.ignoreAlias);
            });
            items.forEach(function(item) {
              item.$$hasDuplicateName = duplicateIds.has(item.id);
            });
            return items;
          });
        };
        return $compile(el)(scope);
      },
    };
  },
]);
